import React from "react";
import classNames from "classnames";
import { ColumnType } from "antd/es/table/interface";

interface CellProps {
  column: ColumnType<any>;
  value: any;
  index: number;
  entry: object;
  isLast: boolean;
  style: React.CSSProperties;
  className?: (entity: Object) => string;
  isSelectedCell?: Boolean;
}

const Cell: React.FC<CellProps> = ({
  isLast,
  style,
  column,
  entry,
  value,
  index,
  className,
  isSelectedCell,
}) => (
  <div
    className={classNames(
      "virtual-table-cell",
      className ? className(entry) : null,
      {
        "virtual-table-cell-last": isLast,
        "odd-row": index % 2 !== 0,
        "selected-cell": isSelectedCell,
      }
    )}
    style={style}
  >
    {column.render ? column.render(value, entry, index) : value}
  </div>
);

export default Cell;
